module.exports = __webpack_public_path__ + "icons/original/small/small-f6.2f7d8a98586b23b3f348bef4350bf4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f6.png
// module id = QfaF
// module chunks = app